import { isLogtoEnabled } from '@savgroup-front-common/core/services/isLogtoEnabled';

const { hostname } = window.location;
const logtoClientId = '1qy422j8ogbeeipyd3w17';

const defaultAuthority = isLogtoEnabled()
  ? 'https://idp.revers.io/oidc'
  : 'https://login.revers.io';

const mapClientIdByHostname: Record<string, string> = isLogtoEnabled()
  ? {}
  : {
      localhost: 'field-service-app.revers.io',
    };

const mapAuthorityByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      localhost: defaultAuthority,
    }
  : {
      localhost: defaultAuthority,
    };

const mapDirectSigningByHostname: Record<string, string> = {};

const AuthConfiguration = {
  authority: mapAuthorityByHostname[hostname] || defaultAuthority,
  clientId: isLogtoEnabled()
    ? mapClientIdByHostname[hostname] || logtoClientId
    : mapClientIdByHostname[hostname] || window.location.hostname,
  scope: isLogtoEnabled()
    ? 'openid email api offline_access profile'
    : 'openid email api',
  direct_sign_in: isLogtoEnabled()
    ? mapDirectSigningByHostname[hostname] || undefined
    : undefined,
};

export default AuthConfiguration;
